enum PermissionLevelEnum {
    TOTAL_CONTROL,
    VIEW,
    CREATE,
    UPDATE,
    DELETE,
};

export default PermissionLevelEnum;
